<template>
<!--  <div class="filter-container" v-if="all_items.length || (!all_items.length && period !== 'همه')">-->
  <div class="filter-container">
    <div class="row justify-content-center">
      <div class="col-6">
        <p class="fw-bolder">فیلتر براساس دوره چرخه</p>
        <select class="form-select" v-model="period">
          <option value="همه">همه</option>
          <option v-for="(event, index) in events" :key="index" :value="event.name">{{ event.name }}</option>
        </select>
      </div>
    </div>
  </div>

  <div class="table-responsive">

    <table v-if="all_items.length" class="table table-striped bg-white" style="width: 70vw; ">
      <thead>
      <tr class="sticky-header">
        <th style="width: 1vw;">ردیف</th>
        <th  >مسئله  </th>
        <th> عنوان نماگر</th>
        <th >نوع نماگر     </th>
        <th>فرمول نماگر  </th>
        <th>مقدار ابتدای سال   </th>
        <th style="width: 6.3vw;">مقدار انتهای سال   </th>
        <th >مستندات پیوست  </th>
        <th style="width: 6vw;">وضعیت مسئله    </th>
        <th >راهکار اصلاحی پیشنهادی    </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in all_items">
        <td>{{index+1}}</td>
        <td>{{item.problem && item.problem.title}}</td>
        <td>{{item.title_photographer}}</td>
        <td>{{item.type_photographer}}</td>
        <td>{{item.formula}}</td>
        <td>{{item.value_now}}</td>
        <td>
          <input type="text" class="form-control text-center" v-model="item.value_final">
        </td>
        <td>
          <button @click.prevent="showDocs(item.id)" class="btn btn-submit-1 btn-primary">تکمیل | بروزرسانی</button>
        </td>
        <td>
          <select class="form-select" v-model="item.problem_status" id="">
            <option :value="0">استمرار</option>
            <option :value="1">اتمام</option>
          </select>
        </td>
        <td>
          <textarea v-model="item.solution" cols="30" rows="10" class="form-control"></textarea>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <hr class="m-2">

  <center v-if="all_items.length" class="mb-2 d-flex align-items-center justify-content-center">
    <button @click.prevent="store"  class="btn btn-primary btn-submit-1">ذخیره</button>
    <button  @click.prevent="downloadCompanyDocs"  class="btn btn-primary btn-submit-1 mx-2">خروجی مستندات</button>
    <button   @click.prevent="exportWord"  class="btn btn-primary btn-submit-1 mx-2">خروجی Word</button>
  </center>

  <div v-if="!all_items.length" class="mb-2">اطلاعاتی یافت نشد</div>

  <DocumentsModal
      :status_insert="true"
      :id="id_item"
      v-if="showDocumentsModal"
      :visible="showDocumentsModal"
      @close="showDocs"
  />
</template>
<script>
import {useToast} from "vue-toastification";
import DocumentsModal from "@/components/Impact_Assessment/DocumentsModal/DocumentsModal.vue";
const toast = useToast();

export  default {
  components: {DocumentsModal},
  data(){
    return{
      period: 'همه',
      events: [],
      all_items:[],
      documents:[],
      showDocumentsModal: false,
      id_item: '',
      status_seconder: false,     // وضعیت تأییدکننده (seconder)
      seconder_ban: false,        // بلاک بودن seconder
      approver_ban: false,        // بلاک بودن تأییدکننده (approver)
      status_approver: false,     // وضعیت تأییدکننده (approver)
      status_show: false,         // نمایش وضعیت
      is_fetch: false,            // وضعیت فچ کردن داده‌ها
      textAlert: '',              // پیام هشدار
      status_seconder_step: false,// مرحله وضعیت seconder
      show_insert: false,         // نمایش وضعیت درج
      not_show: true,             // نمایش یا عدم نمایش مورد خاص
      type_one: false,            // نوع اول
      type_two: false,             // نوع دوم
      stop: false             // نوع دوم
    }
  },
  methods:{
    exportWord() {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`); // اضافه کردن توکن

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/impact-assessment/get_word`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.download_url) {
              // باز کردن لینک در تب جدید
              window.open(result.download_url, '_blank');
            } else {
              throw new Error('Download URL not provided');
            }
          })
          .catch(error => {
            toast.error('خطا در دریافت فایل!');
          });
    },




    showDocs(id){
      this.showDocumentsModal = !this.showDocumentsModal;
      this.id_item = id
    },
    addDocs(){},
    deleteMethodFile(){},
    all(){
      if (this.stop)return false;

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('period', this.period)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/Problem_identification/completed_problems_photograph`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error){
              return;
            }
            if (result.data.completed_problems.details){
              this.all_items = result.data.completed_problems.details
            }
            if (result.data.events) {
              this.events = result.data.events
            }
          })
          .catch();
    },
    store(){

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('items',JSON.stringify(this.all_items))

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/impact-assessment/store_photographer`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error){
              toast.error(result.error)

              return;
            }
            toast.success(result.message)
             this.all()

          })
          .catch();
    },
    async downloadCompanyDocs() {
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

        const response = await fetch(`${this.base_url}/impact-assessment/download_photographer_doc`, {
          method: "GET",
          headers: myHeaders,
        });

        if (!response.ok) {
          const errorData = await response.json();
        toast.error(errorData.error)
        }

        // دریافت فایل ZIP به صورت blob
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        // ایجاد لینک برای دانلود
        const a = document.createElement("a");
        a.href = url;
        a.download = `company_docs_${Date.now()}.zip`; // نام فایل دانلودی
        document.body.appendChild(a);
        a.click();
        a.remove();

        // آزاد کردن URL blob
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error(error.message);
        this.$toast.error(error.message || "خطا در ارتباط با سرور");
      }
    },
    setShow() {
      if (this.$cookies.isKey('type_2')) {
        if (this.status_show === false) {
          this.show_insert = true
          return;
        }
        this.show_insert = true
      }
      this.show_insert = false
    },

    result_company(){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/impact-assessment/result_company`, requestOptions)
          .then(response => response.json())
          .then(response => {
            this.status_seconder = false
            this.seconder_ban = false
            this.approver_ban = false
            this.status_approver = false
            if (response.status) {
              this.status_show = true
            }
            this.is_fetch = false
            this.setShow()
            if (!response.status_seconder) {
              if (response.status) {
                this.status_seconder = true
              }
            }
            if (!this.status_approver && this.$cookies.isKey('type_1')) {
              this.status_seconder = false
            }
            if (response.status && !response.status_approver) {
              this.status_seconder = true
            }
            if (response.seconder_ban) {
              this.seconder_ban = true
              this.textAlert = response.message ?? 'موردی یافت نشد'
            }
            if (response.approver_ban) {
              this.approver_ban = true
              this.textAlert = response.message ?? 'موردی یافت نشد'
            }

            if (response.status_approver) {
              this.status_approver = true
            }
            if (response.text_seconder) {
              this.seconder_ban = true
              this.textAlert = response.text_seconder ?? 'موردی یافت نشد'
            }
            if (parseInt(response.step) === 1) {
              this.status_seconder_step = true
              this.status_seconder = true
            }
            if (parseInt(response.step) === 2) {
              this.status_seconder_step = true
              this.status_seconder = false
            }
            if (parseInt(response.step) === 0) {
              this.status_seconder_step = false

            }
            this.show_insert = response.status_insert

            if ((parseInt(response.step)===1&&this.type_two)||(parseInt(response.step)===2&&this.type_two) || (parseInt(response.step)===2&&this.type_one) || parseInt(response.step)===3){
              this.not_show = false
            }
            if (parseInt(response.step) === 4) {
              this.status_seconder_step = false
              this.isWrite = true
              this.stop = true
            }
            this.all()

          })
          .catch();
    },


  },
  watch: {
    period: function () {
      this.result_company()
    },
  },
  mounted() {
    this.result_company()
  },
}

</script>
<style scoped>
.filter-container {
  padding: 0 20vw;
  margin: 3vw auto
}
</style>